import Vue from 'vue';
import Router from 'vue-router';

import About from '@/components/About';
import News from '@/components/News';
import NewsGallery from '@/components/NewsGallery';
import Items from '@/components/Items';
import Item from '@/components/Item';
import Constructor from '@/components/Constructor';
import Contact from '@/components/Contact';
import Agc from '@/components/Agc';
import AgcItem from '@/components/AgcItem';
import Home from '@/components/Home';
import LandingPage from '@/components/LandingPage/View';
import References from '@/components/References';
import PrivacyStatement from '@/components/PrivacyStatement';
import LegalNotice from '@/components/LegalNotice';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [{
    path: '/rolunk',
    name: 'About',
    component: About,
  }, {
    path: '/hireink',
    name: 'News',
    component: News,
  }, {
    path: '/hireink/:slug',
    name: 'NewsGallery',
    component: NewsGallery,
  }, {
    path: '/termekeink',
    name: 'Items',
    component: Items,
  }, {
    path: '/termekeink/:_id',
    name: 'Item',
    component: Item,
  }, {
    path: '/tervezo',
    name: 'Constructor',
    component: Constructor,
  }, {
    path: '/kapcsolat',
    name: 'Contact',
    component: Contact,
  }, {
    path: '/agc',
    name: 'Agc',
    component: Agc,
  }, {
    path: '/agc/:_id',
    name: 'AgcItem',
    component: AgcItem,
  }, {
    path: '/feliratkozas',
    name: 'LandingPage',
    component: LandingPage,
  }, {
    path: '/referenciak',
    name: 'References',
    component: References,
  }, {
    path: '/referenciak/:_id',
    name: 'ReferencesItem',
    component: References,
  }, {
    path: '/adatvedelmi-nyilatkozat',
    name: 'PrivacyStatement',
    component: PrivacyStatement,
  }, {
    path: '/jogi-nyilatkozat',
    name: 'LegalNotice',
    component: LegalNotice,
  }, {
    path: '*',
    name: 'Home',
    component: Home,
  }],
});



// WEBPACK FOOTER //
// ./src/router.js